import { render } from "./RolePerfConfigs.vue?vue&type=template&id=0fc75ba6"
import script from "./RolePerfConfigs.vue?vue&type=script&lang=js"
export * from "./RolePerfConfigs.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__